import { AxiosResponse } from "axios";
import { authApi } from "../instances";
import { ANALYSIS_PATHS} from "../paths/index.paths";
import { CategoriesGetReq, CategoriesGetRes } from "../../types/api/categories.api.types";
import { ConvertDataToGetParams } from "../../utils/ConvertDataToGetParams";

export class CategoriesApi {
    static async GetByTitle(req: CategoriesGetReq): Promise<AxiosResponse<CategoriesGetRes>> {
        const res: AxiosResponse<CategoriesGetRes> = await authApi.get(`${ANALYSIS_PATHS.GET_CATEGORIES}${ConvertDataToGetParams(req)}`);
        if (!res.data) {
            throw res
        }
        return res
    }
}